import querystring from 'querystring';

import _ from 'lodash';

import splitUrl from './splitUrl';

const extractNonEmptyParams = queryString => {
  return _.pickBy(queryString, (val, key) => !!key);
};

const extractParams = (url = '') => {
  return extractNonEmptyParams(querystring.parse(splitUrl(url).queryString));
};

export default extractParams;
